import React, { useState, useEffect } from "react";

// Sample country code list (you can expand this)
const countryCodes = [
  { name: "Philippines", code: "+63", iso2: "PH", flag: "🇵🇭" },
  { name: "United States", code: "+1", iso2: "US", flag: "🇺🇸" },
  { name: "United Kingdom", code: "+44", iso2: "GB", flag: "🇬🇧" },
  { name: "India", code: "+91", iso2: "IN", flag: "🇮🇳" },
  { name: "Japan", code: "+81", iso2: "JP", flag: "🇯🇵" },
  { name: "China", code: "+86", iso2: "CN", flag: "🇨🇳" },
  { name: "Germany", code: "+49", iso2: "DE", flag: "🇩🇪" },
  { name: "France", code: "+33", iso2: "FR", flag: "🇫🇷" },
  { name: "Canada", code: "+1", iso2: "CA", flag: "🇨🇦" },
  { name: "Australia", code: "+61", iso2: "AU", flag: "🇦🇺" },
];

export default function InputPhoneWithCountry({
  defaultValue = "+63",
  onChange,
  required,
  ...props
}) {
  const [prefix, setPrefix] = useState("+63");
  const [number, setNumber] = useState("");

  // Match prefix from defaultValue
  useEffect(() => {
    const match = countryCodes.find((c) => defaultValue?.startsWith(c.code));
    if (match) {
      setPrefix(match.code);
      setNumber(defaultValue.slice(match.code.length));
    } else {
      setNumber(defaultValue);
    }
  }, [defaultValue]);

  const handlePrefixChange = (e) => {
    const newPrefix = e.target.value;
    setPrefix(newPrefix);
    onChange?.(`${newPrefix}${number}`);
  };

  const handleNumberChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 15); // max 15 digits
    setNumber(raw);
    onChange?.(`${prefix}${raw}`);
  };

  return (
    <div className="d-flex">
      <select
        className="form-select border-1 border-dark-subtle border-end-0"
        value={prefix}
        onChange={handlePrefixChange}
        disabled
        style={{ maxWidth: "10rem", borderRadius: "5px 0 0 5px" }}
      >
        {countryCodes.map((c) => (
          <option
            key={c.code + c.iso2}
            value={c.code}
            selected={countryCodes[0]}
          >
            {c.flag} {c.iso2} ({c.code})
          </option>
        ))}
      </select>
      <input
        type="text"
        className="form-control border border-1 border-dark-subtle border-start-0 bg-white"
        style={{ borderRadius: "0 5px 5px 0" }}
        value={number}
        onChange={handleNumberChange}
        required={required}
        placeholder="Enter phone number"
        {...props}
      />
    </div>
  );
}
